import {
  InlineResponse2002,
  PremiumsEasyPayChangeBody,
  PremiumsEasyPayStartBody,
  PremiumsEasyPaySummary
} from '@cms-max/medicare-api-sdk'
import { AxiosError } from 'axios'
import { medicareApiClient } from 'clients/medicareApiClient'
import { useTranslation } from 'react-i18next'
import { useMutation, useQuery, useQueryClient } from 'react-query'

const easyPayKeys = {
  summary: 'easyPaySummary' as const
}

export const useEasyPaySummary = () => {
  const fetchEasyPaySummary = async () => {
    const res = await medicareApiClient.premiumsApi.getEasyPaySummary()

    return res.data
  }

  return useQuery<PremiumsEasyPaySummary | undefined, AxiosError>(
    [easyPayKeys.summary],
    fetchEasyPaySummary
  )
}

export function useEasyPayChange () {
  const queryClient = useQueryClient()
  const { i18n } = useTranslation()

  const changeEasyPay = async (payload: PremiumsEasyPayChangeBody) => {
    const res = await medicareApiClient.premiumsApi.changeEasyPayEnrollment(
      payload,
      {
        headers: {
          'Accept-Language': i18n.language
        }
      }
    )
    return res.data
  }

  return useMutation<InlineResponse2002, AxiosError, PremiumsEasyPayChangeBody>(
    {
      mutationFn: changeEasyPay,

      onSettled: () => {
        queryClient.invalidateQueries({ queryKey: [easyPayKeys.summary] })
      }
    }
  )
}

export function useEasyPayStart () {
  const queryClient = useQueryClient()
  const { i18n } = useTranslation()

  const startEasyPay = async (payload: PremiumsEasyPayStartBody) => {
    const res = await medicareApiClient.premiumsApi.startEasyPayEnrollment(
      payload,
      {
        headers: {
          'Accept-Language': i18n.language
        }
      }
    )
    return res.data
  }

  return useMutation<InlineResponse2002, AxiosError, PremiumsEasyPayStartBody>({
    mutationFn: startEasyPay,

    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: [easyPayKeys.summary] })
    }
  })
}

export function useEasyPayStop () {
  const queryClient = useQueryClient()
  const { i18n } = useTranslation()

  const stopEasyPay = async () => {
    const res = await medicareApiClient.premiumsApi.stopEasyPayEnrollment({
      headers: {
        'Accept-Language': i18n.language
      }
    })
    return res.data
  }

  return useMutation<InlineResponse2002, AxiosError>({
    mutationFn: stopEasyPay,

    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: [easyPayKeys.summary] })
    }
  })
}
